import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, FileText, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function RegistrationRequiredModal({ isOpen, onClose, pendingRegistrations = [] }) {
  const navigate = useNavigate();

  const handleGoToRegistration = () => {
    onClose();
    navigate('/pendaftaran-kanak-kanak');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-orange-600">
            <AlertTriangle className="w-6 h-6" />
            Pendaftaran Anak Diperlukan
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <p className="text-gray-700">
              Untuk menggunakan sistem sepenuhnya, sila daftarkan anak anda terlebih dahulu. 
              Tanpa pendaftaran anak, anda tidak dapat mengakses:
            </p>
            <ul className="mt-3 space-y-2 text-sm text-gray-600">
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                Aktiviti Harian Pelajar
              </li>
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                Rekod Pelajar
              </li>
            </ul>
          </div>

          {pendingRegistrations.length > 0 && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <p className="text-sm font-medium text-yellow-800 mb-2">
                Anda mempunyai {pendingRegistrations.length} pendaftaran menunggu kelulusan:
              </p>
              <ul className="space-y-1">
                {pendingRegistrations.map((reg) => (
                  <li key={reg.id} className="text-sm text-yellow-700">
                    • {reg.child_full_name || "Belum diisi"} ({reg.status === "pending_approval" ? "Menunggu" : "Draf"})
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Tutup
            </Button>
            <Button
              onClick={handleGoToRegistration}
              className="flex-1 bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600"
            >
              <FileText className="w-4 h-4 mr-2" />
              Daftar Anak
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
